<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/packing_house/production/packing_by_pallet/show_process.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-4">
    <h1 class="page-title">
      <i class="fa-solid fa-container-storage"></i
      ><span class="space-icon"></span>
      {{ $t("labels.containers_title") }}
    </h1>

    <div class="mt-4 flex flex-row">
      <div class="panel-plain-label">
        <badge-default
          :label="total_rows + ' ' + $t('labels.total_containers')"
        />
      </div>
    </div>

    <div class="mt-2 flex flex-col">
      <ag-grid-vue
        style="height: 600px"
        class="ag-theme-alpine"
        @grid-ready="onGridReady"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="containers"
      >
      </ag-grid-vue>
    </div>

    <table-paginator
      v-model="current_page"
      v-if="Number(total_rows) > rows_per_page"
      :total_rows="total_rows"
      :rows_per_page="rows_per_page"
    >
    </table-paginator>
  </div>
</template>

<script>
import Requester from "@/views/packing_house/requesters/production/packing_by_pallet/show_process.js";
import { AgGridVue } from "ag-grid-vue3";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";
import GoToLink from "@/components/views/layout/ag_grid/GoToLink.vue";

export default {
  name: "PHProductionPackingByPalletShowProcessContainers",
  components: { AgGridVue, TablePaginator },
  data() {
    return {
      current_page: 1,
      rows_per_page: 12,
      total_rows: 0,
      containers: [],
      defaultColDef: {
        sortable: true,
        filter: true,
        floatingFilter: true,
      },
      columnDefs: [
        {
          headerName: this.$t("model.container.week"),
          field: "week",
          filter: "agNumberColumnFilter",
          width: 50,
        },
        {
          headerName: this.$t("model.container.agro_exporter"),
          field: "agro_exporter.name",
          filter: "agNumberColumnFilter",
          width: 50,
        },
        {
          headerName: this.$t("model.container.container_code"),
          field: "container_code",
          filter: true,
          cellRendererSelector: (params) => {
            return {
              component: GoToLink,
              params: {
                text: params.value,
                path_name: this.routeName("show_container"),
                params_path: {
                  packing_house_id: this.packing_house_id,
                  packing_house_process_id: this.packing_house_process_id,
                  container_id: params.data.id,
                },
              },
            };
          },
        },
        {
          headerName: this.$t("model.container.exporter_process_crop_category"),
          field: "category_name",
          filter: true,
        },
        {
          headerName: this.$t("model.container.exporter_process_brand"),
          field: "brand_name",
          filter: true,
        },
        {
          headerName: `${this.$t("model.container.gross_weight")} (Kg)`,
          field: "gross_weight",
          filter: true,
        },
        {
          headerName: `${this.$t("model.container.net_weight")} (Kg)`,
          field: "net_weight",
          filter: true,
        },
        {
          headerName: `${this.$t("model.container.package_groups")} (Kg)`,
          field: "package_groups.length",
          filter: true,
        },
      ],
    };
  },
  props: {
    packing_house_id: {},
    packing_house_process_id: {},
  },
  watch: {
    current_page: function () {
      this.fetchContainers();
    },
  },
  created() {
    this.fetchContainers();
  },
  methods: {
    fetchContainers: async function () {
      const response = await Requester.fetchContainers(
        this.packing_house_id,
        this.packing_house_process_id,
        this.current_page,
        this.rows_per_page
      );
      this.containers = response.data.records;
      this.total_rows = response.data.total_rows;
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit({ defaultMinWidth: 150 });
    },
  },
};
</script>
